// app/javascript/controllers/disable_on_submit_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['disable'];

  connect() {
    this.element.addEventListener('turbo:submit-start', this.disable.bind(this));
    this.element.addEventListener('turbo:submit-end', this.enable.bind(this));

    const form = this.element.querySelector("form[data-turbo='false']");

    if (form) {
      form.addEventListener('submit', this.formWithoutTurbo.bind(this));
    }
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-start', this.disable.bind(this));
    this.element.removeEventListener('turbo:submit-end', this.enable.bind(this));

    const form = this.element.querySelector("form[data-turbo='false']");

    if (form) {
      form.removeEventListener('submit', this.formWithoutTurbo.bind(this));
    }
  }

  formWithoutTurbo() {
    const form = this.element.querySelector("form[data-turbo='false']");

    const submitButton = form.querySelector('button[type="submit"]');

    if (submitButton) {
      submitButton.querySelector('span.capitalize.title-btn').innerText = submitButton.dataset.disableWith;

      submitButton.disabled = true;

      form.addEventListener(
        'ajax:complete',
        function () {
          submitButton.querySelector('span.capitalize.title-btn').innerText = submitButton.dataset.revertText;
          submitButton.disabled = false;
        },
        { once: true },
      );
    }
  }

  disable() {
    this.disableTargets.forEach((element) => {
      element.disabled = true;
    });

    const submitButton = this.element.querySelector('.form-loading button[type="submit"]');

    if (submitButton !== null) {
      this.originalButtonText = submitButton.innerHTML;

      submitButton.innerHTML = `
        <div class="spa-button-overlay"></div>
        <div class="flex relative gap-4 items-center z-1">
          <span class="capitalize title-btn">Submitting...</span>
        </div>
      `;

      return;
    }

    const inputButton = this.element.querySelector('.form-loading input[type="submit"]');

    if (inputButton !== null) {
      this.originalButtonText = inputButton.value;

      inputButton.value = 'Submitting...';
    }
  }

  enable() {
    this.disableTargets.forEach((element) => {
      element.disabled = false;
    });

    const submitButton = this.element.querySelector('.form-loading button[type="submit"]');

    if (submitButton !== null) {
      submitButton.innerHTML = `
        <div class="spa-button-overlay"></div>
        <div class="flex relative gap-4 items-center z-1">
          <span class="capitalize title-btn">${submitButton.dataset.revertText || this.originalButtonText}</span>
        </div>
      `;

      return;
    }

    const inputButton = this.element.querySelector('.form-loading input[type="submit"]');

    if (inputButton !== null) {
      inputButton.value = inputButton.dataset.revertText || this.originalButtonText;
    }
  }
}
